React = require 'react'
$ = require 'jquery'
Auth = require 'db/auth'
Controller = require 'controller'
CreateBoardComponent = require 'views/board-create/create-board-component'
CreateOrgView = require 'views/organization/create-org-view'
Dialog = require 'views/lib/dialog'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
ClientConfig = require 'debug/client-config'
headerAddMenu = require 'views/templates/header_add_menu'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'

module.exports = class HeaderAddMenuView extends View
  viewTitleKey: 'create'

  initialize: ->
    @trackingOpts = { category: 'header', method: 'by clicking create team in header add menu' }

  events:
    'click .js-new-board': 'newBoard'
    'click .js-new-org': 'newOrg'
    'click .js-new-bc-org': 'newBCOrg'
    'click .js-new-ent-org': 'newEnterpriseOrg'

  render: ->
    @$el.html(
      headerAddMenu({
        upsellEnabled: !ClientConfig.get('dontUpsell')
        hasEnterprises: @model.enterpriseList.length > 0
        confirmed: @model.get('confirmed')
      })
    )

    @

  newBoard: (e) ->
    track("Header", "Add Menu", "New Board")

    Util.stop(e)

    if maybeDisplayMemberLimitsError($(e.target), null, Auth.me())
      return

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: Controller.getCurrentOrganization()
        trackingOpts: { category: 'header', method: 'by clicking create board in header add menu' }

  newOrg: (e) ->
    track("Header", "Add Menu", "New Org")

    Util.stop(e)

    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, @trackingOpts })

  newBCOrg: (e) ->
    track("Header", "Add Menu", "New Business Class Org")
    createOpts = { isBusinessClass: true }

    Util.stop(e)

    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts, @trackingOpts })

  newEnterpriseOrg: (e) ->
    track("Header", "Add Menu", "New Enterprise Org")
    createOpts = { isEnterprise: true }

    Util.stop(e)

    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts, @trackingOpts })



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-add-menu-view.coffee